<div class="main-Content d-flex">
    <h3>Update Customer</h3>
    <div class="container-fluid d-flex flex-column mat-table mat-elevation-z1 flex-2 px-5 py-5">
      <form [formGroup]="formModel" autocomplete="off">
        <div class="col-sm-12">
          <div class="form-group row">
                 
            <div class="col-sm-4" style="margin-top: 15px;">
              <label>First Name </label>
              <input class="form-control" formControlName="FirstName" autocomplete="off">
              <label class="text-danger" *ngIf="formModel.get('FirstName').errors?.required && submitted">First Name is
                required.</label>
            </div>
            <div class="col-sm-4" style="margin-top: 15px;">
              <label>Last Name </label>
              <input class="form-control" formControlName="LastName" autocomplete="off">
              <label class="text-danger" *ngIf="formModel.get('LastName').errors?.required && submitted">Last Name is
                required.</label>
            </div>
  
            <div class="col-sm-4" style="margin-top: 15px;">
              <label>Mobile</label>
              <input class="form-control" formControlName="Mobile">
              <label class="text-danger" *ngIf="formModel.get('Mobile').errors?.required && submitted">Mobile number is
                required.</label>
              <label class="text-danger"
                *ngIf="formModel.get('Mobile').touched && formModel.get('Mobile').errors?.pattern">Please enter 10 digit
                mobile number.</label>
            </div>
  
            <div class="col-sm-4" style="margin-top: 15px;">
              <label>Email<span style="color: #ff232382;">*</span> </label>
              <input class="form-control" formControlName="Email">
              <label class="text-danger" *ngIf="formModel.get('Email').errors?.required && submitted">Email Address is
                required.</label>
              <label class="text-danger"
                *ngIf="formModel.get('Email').touched && formModel.get('Email').errors?.email">Please enter valid email
                address.</label>                
            </div>

            <div class="col-sm-4" style="margin-top: 15px;">
                <label>Status<span style="color: #ff232382;">*</span></label>                
                <select class="form-control" formControlName="Status">
                    <option value=1 > Active </option>
                    <option value=0> InActive </option>
                    <option value=2> Delete </option>
                </select>
                <label class="text-danger" *ngIf="formModel.get('Status').errors?.required && submitted">Status is
                  required.</label>              
              </div>
           
          </div>              
        </div>
  
          <div class="form-group row">
            <div class="col-sm-12 mt-3">
              <div class="text-center">
                <button  (click)="onSubmit()"  class="btn btn-ok"><span *ngIf="loading" style="border-width:0.1em;" class="spinner-border spinner-border-sm mr-2"></span>Update User</button>&nbsp;&nbsp;&nbsp;
                <button  (click)="onClose()" class="btn btn-close">Close</button> 
              </div>
            </div>
          </div>
      </form>
    </div>
  </div>